import script from "./DUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./DUpload.vue?vue&type=script&setup=true&lang=js"

import "./DUpload.vue?vue&type=style&index=0&id=f8dae47a&lang=scss"

const __exports__ = script;

export default __exports__